import { GmailMessageParsed } from '~common/google-api/types'

export function detectStripeEmail(email: GmailMessageParsed): boolean {
    if (!email?.htmlContent) {
        return false
    }

    if (email?.htmlContent?.includes('files.stripe.com')) {
        return true
    }

    if (email?.htmlContent?.includes('email.stripe.com')) {
        return true
    }
    if (email?.htmlContent?.includes('Learn more about Stripe')) {
        return true
    }

    // Fallback: check for specific text
    return false
}
